import * as React from 'react';
import { Input as AntInput } from 'antd';
import { TextAreaProps as AntTextAreaProps } from 'antd/lib/input';

export type TextAreaProps = {
  autoSize: boolean | Record<string, unknown>;
  defaultValue?: string;
  value?: string;
  placeholder?: string;
  onPressEnter?: () => void;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  allowClear: boolean;
  onResize?: () => Record<string, unknown>;
  rows?: number;
  disabled: boolean;
};

const TextArea = (props: TextAreaProps & AntTextAreaProps) => {
  const { className } = props;
  const classNames = [className, 'input', 'text-area'];
  return <AntInput.TextArea {...props} className={classNames.join(' ')} />;
};

TextArea.defaultProps = {
  autoSize: false,
  allowClear: true,
  disabled: false,
};

export default TextArea;
